
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import AsahiButton from '@/components/library/AsahiButton.vue'
import formatDateMixin from '@/utils/mixin'

interface RoleDetail {
  rolename: string;
  roleid: string;
  permission: string;
  roleType: string;
  customerType: string;
  possibleRoles: string;
}

export default defineComponent({
  name: 'AsahiBsSearchProducts',
  emits: ['closeModal'],
  components: {
    AsahiButton
  },
  props: {
    searchType: {
      type: String
    }
  },
  mixins: [formatDateMixin],
  computed: {
    ...mapState('catalog', ['products']),
    isMobile () {
      return window.innerWidth <= 768
    },
    customerType () {
      const customerTypeArray = this.$store.state.auth.user.permissionSchema
        .filter(permission => permission?.rpDetails.some((item: RoleDetail) => item.customerType.toLowerCase() !== ''))
      return customerTypeArray ? customerTypeArray[0]?.rpDetails[0]?.customerType : ''
    },
    isOnTradeCustomer () {
      return this.customerType ? (this.customerType.toLowerCase() === 'ontrade') : false
    }
  },
  methods: {
    navigateToProducts () {
      localStorage.setItem('searchTypeProduct', this.searchType || '')
      this.$router.push('/catalog/products')
      this.$emit('closeModal')
    },
    navigateToProductPage (item: any) {
      this.$navigate(`/catalog/${item.sku}`)
      this.$emit('closeModal')
    }
  }
})
